/* Hedayat Music - Lecture exclusive sur la page Demos.
   Quand un player demarre (audio/video natif, widget SoundCloud ou embed Spotify),
   tous les autres players de la page sont mis en pause. Correctif additif, ne modifie
   aucune logique existante. */
(function () {
  'use strict';

  function pauseAllNativeMedia(except) {
    var medias = document.querySelectorAll('audio, video');
    for (var i = 0; i < medias.length; i++) {
      if (medias[i] !== except && !medias[i].paused) {
        try { medias[i].pause(); } catch (err) {}
      }
    }
  }

  /* --- SoundCloud widgets --- */
  var scWidgets = [];

  function pauseAllSoundcloud(except) {
    for (var i = 0; i < scWidgets.length; i++) {
      if (scWidgets[i] !== except) {
        try { scWidgets[i].pause(); } catch (err) {}
      }
    }
  }

  /* --- Spotify embeds (tentative de pause via postMessage, best effort) --- */
  function pauseSpotify() {
    var frames = document.querySelectorAll('iframe[src*="open.spotify.com"]');
    for (var i = 0; i < frames.length; i++) {
      try { frames[i].contentWindow.postMessage({ command: 'pause' }, '*'); } catch (err) {}
    }
  }

  /* 1) Audio/video natifs : delegation en capture au niveau document */
  document.addEventListener('play', function (e) {
    var current = e.target;
    if (!current || typeof current.pause !== 'function') return;
    pauseAllNativeMedia(current);
    pauseAllSoundcloud(null);
    pauseSpotify();
  }, true);

  /* 2) SoundCloud : chargement de l'API officielle du widget puis binding PLAY */
  function initSoundcloud() {
    if (!window.SC || !window.SC.Widget) return;
    var frames = document.querySelectorAll('iframe[src*="w.soundcloud.com/player"]');
    for (var i = 0; i < frames.length; i++) {
      (function (iframe) {
        try {
          var widget = window.SC.Widget(iframe);
          scWidgets.push(widget);
          widget.bind(window.SC.Widget.Events.PLAY, function () {
            pauseAllNativeMedia(null);
            pauseAllSoundcloud(widget);
            pauseSpotify();
          });
        } catch (err) {}
      })(frames[i]);
    }
  }

  function setupSoundcloud() {
    if (!document.querySelector('iframe[src*="w.soundcloud.com/player"]')) return;
    if (window.SC && window.SC.Widget) {
      initSoundcloud();
      return;
    }
    var script = document.createElement('script');
    script.src = 'https://w.soundcloud.com/player/api.js';
    script.async = true;
    script.onload = initSoundcloud;
    document.head.appendChild(script);
  }

  /* 3) Spotify : detection de lecture via les messages playback_update de l'embed */
  window.addEventListener('message', function (e) {
    if (typeof e.origin !== 'string' || e.origin.indexOf('open.spotify.com') === -1) return;
    var data = e.data;
    if (data && data.type === 'playback_update' && data.payload && data.payload.isPaused === false) {
      pauseAllNativeMedia(null);
      pauseAllSoundcloud(null);
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupSoundcloud);
  } else {
    setupSoundcloud();
  }
})();
